'use client';

import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@shared/components/shadcn';
import { useGamesList } from '@shared/hooks';
import { Spinner } from '@shared/icons';
import { imagePathResolver, ROUTES, useClientConfig, useIsMobile } from '@shared/utils';
import { useTranslations } from 'next-intl';
import { ClassicGameCard } from '../../../ClassicGameCard/ClassicGameCard';

type GamesModalProps = {
  gamesNames: string[];
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
};

function GamesModal({ gamesNames, isOpen, onOpenChange }: GamesModalProps) {
  const t = useTranslations('offers.page.obs.offer.cta');
  const tBrowseGames = useTranslations('offers.page.obs.offer.browse_games');

  const isMobile = useIsMobile();
  const { baseImgUrl } = useClientConfig();
  const { games, isLoading } = useGamesList();

  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent className={isMobile ? 'max-h-[calc(100vh-64px)]' : ''} side={isMobile ? 'bottom' : 'right'} data-testid="games-modal">
        <SheetHeader>
          <SheetTitle className="heading-5">{tBrowseGames('title')}</SheetTitle>
        </SheetHeader>
        {isLoading ? (
          <div className="flex justify-center items-center h-full">
            <Spinner size="large" />
          </div>
        ) : (
          <div className="ml-4 mr-4">
            {gamesNames.map((gameName, index) => {
              const game = games.find(gameItem => gameItem.name === gameName);

              const { image, name, displayName, provider } = game ?? {};
              if (!name) return null;
              return (
                <ClassicGameCard
                  className={`mb-4 h-25.5`}
                  key={name}
                  id={name}
                  gameName={displayName ?? name}
                  backgroundImage={imagePathResolver(image ?? '', baseImgUrl, true)}
                  href={ROUTES.CASINO.GAME(name)}
                  playButtonText={t('play')}
                  infoButtonHref={ROUTES.CASINO.GAME_INFO(name)}
                  gameProvider={provider?.[0] ?? ''}
                  position={index}
                  variant="list"
                />
              );
            })}
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}

export { GamesModal };
